<template>
<div class="mt-3 py-5">
	<b-container class="px-3 p-md-0">
		<b-row>
			<b-col cols="12" md="8" class="m-auto px-3">

        <div class="container">

					<div class="row justify-content-center pt-2 pb-5">

              <nav class="pankuzu w-100">
                <ul class="my-4">
                  <li><img class="" src="/static/img/icon/pankuzu.png" style="height: 17px;padding-bottom: 3px;"><a @click="jump(0)">  ピアチュウ TOP</a></li>
                  <li>  利用料について</li>
                </ul>
              </nav>

              <div class="card"> 
                <div class="card-header text-center">中古ピアノ販売事業者として登録する場合の利用料について</div>
                <div class="card-body">
                  <h2>登録・掲載料</h2>
                  <p>中古ピアノ販売事業者としてのご登録および事業者ページや商品（ピアノ）の掲載には費用は一切かかかりません。すべての集客および管理機能を無料で使うことができます。</p>
                  <h2>販売手数料</h2>
                  <p>サイトに掲載された商品（ピアノ）からの購入申し込みがあった場合のみ、以下の販売手数料を指定口座にお支払いください。ただし、最終的にユーザー様に購入の意思がなく、代金の支払いもなかった場合には販売手数料を全額ご返金致します。<br>
                    <ul>
                      <li>アップライトピアノ：　販売金額（サイト上での販売決済額）の10％　上限3万円</li>
                      <li>グランドピアノ　　：　販売金額（サイト上での販売決済額）の3% 　上限5万円</li>
                    </ul>
                  </p>
                  <h2>お支払いの流れ</h2>
                  <p>月末締め　（その月の販売手数料の明細と額を提示）<br> ↓<br> 翌月 20日までにお振込み<br> </p> <br>
                  <p>※システム処理の関係上、月末にその月のサイト上でのすべての購入申し込みについて、販売手数料の計算を行い、次月にピアノ販売事業者様へご請求いたします。もし請求に沿って販売手数料をお支払いの後、最終的にユーザー様に購入の意思がなく、代金の支払いもなかった場合には、その販売手数料を全額ご返金致します。 この点について、予めご理解をお願いいたします。<br> </p>
                </div>
              </div>

					</div>

        </div>

			</b-col>
		</b-row>
	</b-container>
</div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'ChargeSeller',
  data() {
    return {
    }
  },
  methods: {
    jump(number) {
      if (number==0) {
        this.$router.push({path: '/'});
      }
    },
  },
	computed: {
	},
  created() {
  },
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/ChargeSeller.vue